<template>
  <span :class="cls"><slot/></span>
</template>


<script>
export default {
  props: {
    color: {
      default: 'primary'
    }
  },
  computed: {
    cls() {
      return {
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap': true,
        'bg-yellow-100 text-yellow-800': this.color === 'yellow',
        'bg-red-100 text-red-800': this.color === 'red',
        'bg-orange-100 text-orange-800': this.color === 'orange',
        'bg-green-100 text-green-800': this.color === 'green',
        'bg-blue-100 text-blue-800': this.color === 'blue',
        'bg-indigo-100 text-indigo-800': this.color === 'indigo',
        'bg-purple-100 text-purple-800': this.color === 'purple',
        'bg-primary-100 text-primary-800': this.color === 'primary',
        'bg-pink-100 text-pink-800': this.color === 'pink',
      }
    }
  }
}
</script>